import * as moment from 'moment';

const obj = {
  NEW_ACCOUNT_KEY: 'createNewAccount',

  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DELETED: 'deleted',

  DEFAULT_CONTENT_LANGUAGE: 'en',
  ITEMS_PER_PAGE: 20,

  HOTELS_TAXES_PERCENTAGE: 13,
  TOURS_TAXES_PERCENTAGE: 0,

  CREATED_DATE_OPTIONS: {
    today: true,
    yesterday: true,
    this_week: true,
    last_week: true,
    this_month: true,
    last_month: true,
    custom_range: true,
  },

  DOCUMENT_DATE_OPTIONS: {
    today: true,
    yesterday: true,
    this_week: true,
    last_week: true,
    this_month: true,
    last_month: true,
    next_month: true,
    custom_range: true,
  },

  DUE_DATE_OPTIONS: {
    today: true,
    yesterday: true,
    this_week: true,
    last_week: true,
    this_month: true,
    last_month: true,
    next_month: true,
    custom_range: true,
  },

  SERVICE_DATE_OPTIONS: {
    today: true,
    yesterday: true,
    this_week: true,
    last_week: true,
    this_month: true,
    last_month: true,
    next_month: true,
    custom_range: true,
  },

  ATV_ENDPOINT: 'atv_webhooks/update_cr_document_status/', // TODO not needed as edocs is not used anymore

  ITEM_IMAGE_WIDTH: 360,
  ITEM_IMAGE_HEIGHT: 360, // make dinamic for users, products, etc

  IMAGE_MAX_SIZE: 4194304, //bytes = 4MB
  IMAGE_PERMITTED_FORMAT: {
    'image/png': 'image/png',
    'image/jpeg': 'image/jpeg',
    'image/jpg': 'image/jpg',
    'image/gif': 'image/gif',
  },

  DEFAULT_IMAGE: 'assets/img/default_logo.jpg',

  APP_LANGUAGES: [
    {
      name: 'English',
      code: 'en',
    },
    {
      name: 'Spanish',
      code: 'es',
    },
  ],

  PRODUCT_TYPES: [
    { type: 'tour', name: 'TOUR', icon: 'binoculars' },
    { type: 'transportation', name: 'TRANSPORTATION', icon: 'truck' },
    { type: 'hotel', name: 'HOTEL', icon: 'building' },
    { type: 'service_item', name: 'SERVICE_ITEM', icon: 'sitemap' },
    { type: 'package', name: 'PACKAGE', icon: 'suitcase' },
  ],

  ALL_PRODUCT_TYPES: [
    {
      type: 'location',
      model: 'locations',
      name: 'LOCATION',
      icon: 'map-marker',
    },
    { type: 'tour', model: 'tours', name: 'TOUR', icon: 'binoculars' },
    {
      type: 'transportation',
      model: 'transportation',
      name: 'TRANSPORTATION',
      icon: 'truck',
    },
    { type: 'hotel', model: 'hotels', name: 'HOTEL', icon: 'building' },
    { type: 'package', model: 'packages', name: 'PACKAGE', icon: 'suitcase' },
    {
      type: 'hotel_room',
      model: 'hotel_rooms',
      name: 'HOTEL_ROOM',
      icon: 'bed',
    },
  ],

  MEAL_OPTIONS: [
    { type: 'B', name: 'BREAKFAST' },
    { type: 'L', name: 'LUNCH' },
    { type: 'D', name: 'DINNER' },
    { type: 'All', name: 'ALL_INCLUSIVE' },
  ],

  PICKUP_PLACES_OPTIONS: [
    { type: 'hotel', name: 'HOTEL', icon: 'building' },
    { type: 'hostel', name: 'HOSTEL', icon: 'bed' },
    { type: 'place', name: 'PLACE', icon: 'map-marker' },
  ],

  FEATURE_TYPE_OPTIONS: [
    { type: 'quantity', name: 'QUANTITY' },
    { type: 'available', name: 'AVAILABLE' },
  ],

  BILLING_FREQUENCY_OPTIONS: [
    { value: 'month', name: 'MONTH' },
    { value: 'quarterly', name: 'QUARTERLY' },
    { value: 'year', name: 'YEAR' },
  ],

  FREE_TRIAL_OPTIONS: [
    { value: 'month', name: 'MONTH' },
    { value: 'year', name: 'YEAR' },
  ],

  TIME_OPTIONS: [
    { value: 'minutes', name: 'MINUTES' },
    { value: 'hours', name: 'HOURS' },
    { value: 'days', name: 'DAYS' },
  ],

  MASK_BUSINESS: '9-999-999-999',
  MASK_INDIVIDUAL: '9-999-999',

  STAR_OPTIONS: [
    { value: 1, label: 'STAR' },
    { value: 2, label: 'STARS' },
    { value: 3, label: 'STARS' },
    { value: 4, label: 'STARS' },
    { value: 5, label: 'STARS' },
  ],

  // Check-in / Check-out
  CHECK_TIMES: [
    { value: '00', label: '12', meridian: 'am' },
    { value: '01', label: '01', meridian: 'am' },
    { value: '02', label: '02', meridian: 'am' },
    { value: '03', label: '03', meridian: 'am' },
    { value: '04', label: '04', meridian: 'am' },
    { value: '05', label: '05', meridian: 'am' },
    { value: '06', label: '06', meridian: 'am' },
    { value: '07', label: '07', meridian: 'am' },
    { value: '08', label: '08', meridian: 'am' },
    { value: '09', label: '09', meridian: 'am' },
    { value: '10', label: '10', meridian: 'am' },
    { value: '11', label: '11', meridian: 'am' },
    { value: '12', label: '12', meridian: 'pm' },
    { value: '13', label: '01', meridian: 'pm' },
    { value: '14', label: '02', meridian: 'pm' },
    { value: '15', label: '03', meridian: 'pm' },
    { value: '16', label: '04', meridian: 'pm' },
    { value: '17', label: '05', meridian: 'pm' },
    { value: '18', label: '06', meridian: 'pm' },
    { value: '19', label: '07', meridian: 'pm' },
    { value: '20', label: '08', meridian: 'pm' },
    { value: '21', label: '09', meridian: 'pm' },
    { value: '22', label: '10', meridian: 'pm' },
    { value: '23', label: '11', meridian: 'pm' },
  ],

  COUNTRIES: [
    { name: 'COSTA_RICA', code: 'cr' },
    { name: 'NICARAGUA', code: 'ni' },
    { name: 'PANAMA', code: 'pa' },
  ],

  GENDERS: [
    { name: 'MALE', type: 'male' },
    { name: 'FEMALE', type: 'female' },
    { name: 'NOT_DISCLOSED', type: 'genderless' },
  ],

  PAX_TYPES: [
    { name: 'ADULT', type: 'adult' },
    { name: 'CHILD', type: 'child' },
    { name: 'INFANT', type: 'infant' },
    { name: 'SENIOR', type: 'senior' },
  ],

  HEIGHT_UNITS: [
    { name: 'FEET', type: 'feet' },
    { name: 'CM', type: 'cm' },
  ],

  WEIGHT_UNITS: [
    { name: 'POUNDS', type: 'pounds' },
    { name: 'KG', type: 'kg' },
  ],

  LIST_TYPES: [
    { name: 'MANUAL', type: 'manual' },
    { name: 'REFERENCED', type: 'referenced' },
  ],

  RELATIONSHIP_TYPES: [
    { name: 'CLIENTS', type: 'client' },
    { name: 'PROVIDERS', type: 'provider' },
  ],

  GENERALS: [
    { name: 'GENERAL', type: 'general' },
    { name: 'TOURS', type: 'tours' },
    { name: 'HOTELS', type: 'hotels' },
    { name: 'TRANSPORTATIONS', type: 'transportations' },
  ],

  BOOKING_STATUS: [
    {
      value: 'oncart',
      label: 'ONCART',
      icon: 'shopping-cart',
      style: 'warning',
    },
    { value: 'draft', label: 'DRAFT', icon: 'hourglass', style: 'default' },
    {
      value: 'processing',
      label: 'PROCESSING',
      icon: 'spinner',
      style: 'primary',
    },
    { value: 'confirmed', label: 'CONFIRMED', icon: 'check', style: 'success' },
    { value: 'cancelled', label: 'CANCELLED', icon: 'ban', style: 'danger' },
    { value: 'closed', label: 'CLOSED', icon: 'archive', style: 'inverse' },
  ],

  BOOKING_STATUS_PREPAYMENT: [
    {
      value: 'processing',
      label: 'PROCESSING',
      icon: 'spinner',
      style: 'primary',
    },
    { value: 'confirmed', label: 'CONFIRMED', icon: 'check', style: 'success' },
    { value: 'cancelled', label: 'CANCELLED', icon: 'ban', style: 'danger' },
  ],

  INVOICE_STATUSES: [
    { value: 'draft', label: 'DRAFT', icon: 'hourglass', style: 'default' },
    { value: 'open', label: 'OPEN', icon: 'folder-open', style: 'primary' },
    {
      value: 'overdue',
      label: 'OVERDUE',
      icon: 'exclamation-triangle',
      style: 'warning',
    },
    { value: 'unpaid', label: 'UNPAID', icon: 'ban', style: 'danger' },
    { value: 'paid', label: 'PAID', icon: 'check', style: 'success' },
  ],

  PREPAYMENT_STATUSES: [
    { value: 'pending', label: 'PENDING', icon: 'spinner', style: 'primary' },
    { value: 'completed', label: 'COMPLETED', icon: 'check', style: 'success' },
    {
      value: 'processing',
      label: 'PARTIALLY_PROCESSED',
      icon: 'spinner',
      style: 'default',
    },
  ],

  PREPAYMENTS_TYPE: [
    {
      value: 'incoming',
      label: 'INCOMING',
      icon: 'arrow-down',
      style: 'default',
    },
    {
      value: 'outgoing',
      label: 'OUTGOING',
      icon: 'arrow-up',
      style: 'primary',
    },
  ],

  BILL_STATUSES: [
    { value: 'draft', label: 'DRAFT', icon: 'hourglass', style: 'default' },
    { value: 'due', label: 'OPEN', icon: 'spinner', style: 'primary' },
    {
      value: 'overdue',
      label: 'OVERDUE',
      icon: 'exclamation-triangle',
      style: 'warning',
    },
    { value: 'unpaid', label: 'UNPAID', icon: 'ban', style: 'danger' },
    { value: 'paid', label: 'PAID', icon: 'check', style: 'success' },
  ],

  INVOICING_STATUSES: [
    {
      value: 'not_related',
      label: 'NO_INVOICED',
      abbreviation: 'NO_INV',
      icon: 'minus',
      style: 'default',
    },
    {
      value: 'partially',
      label: 'PARTIALLY_INVOICED',
      abbreviation: 'PARTIALLY_INV',
      icon: 'spinner',
      style: 'warning',
    },
    {
      value: 'invoiced',
      label: 'FULLY_INVOICED',
      abbreviation: 'FULLY_INV',
      icon: 'check',
      style: 'success',
    },
  ],

  CREDIT_NOTES_STATUSES: [
    { value: 'draft', label: 'DRAFT', icon: 'hourglass', style: 'default' },
    { value: 'processed', label: 'PROCESSED', icon: 'check', style: 'success' },
  ],

  PROVIDER_CREDIT_NOTES_STATUSES: [
    { value: 'draft', label: 'DRAFT', icon: 'hourglass', style: 'default' },
    { value: 'processed', label: 'PROCESSED', icon: 'check', style: 'success' },
  ],

  // Costa Rica
  ATV_CR_STATUSES: [
    { value: 'pending', icon: 'spinner', label: 'PENDING', style: 'primary' },
    { value: 'accepted', icon: 'check', label: 'ACCEPTED', style: 'success' },
    {
      value: 'accepted_partially',
      icon: 'check-square-o',
      label: 'PARTIALLY_ACCEPTED',
      style: 'warning',
    },
    { value: 'rejected', icon: 'ban', label: 'REJECTED', style: 'danger' },
    // { value: 'sent',               icon: 'paper-plane-o',        label: 'SENT',               style: 'default' },
    {
      value: 'fail',
      icon: 'exclamation-triangle',
      label: 'FAILED',
      style: 'danger',
    },
  ],

  ATV_CR_RECEPTION_STATUSES: [
    { value: 'pending', icon: 'spinner', label: 'PENDING', style: 'primary' },
    {
      value: 'accepted',
      icon: 'check-square',
      label: 'ACCEPTED',
      style: 'success',
    },
    {
      value: 'accepted_partially',
      icon: 'check-square-o',
      label: 'PARTIALLY_ACCEPTED',
      style: 'warning',
    },
    { value: 'rejected', icon: 'ban', label: 'REJECTED', style: 'danger' },
    {
      value: 'fail',
      icon: 'exclamation-triangle',
      label: 'FAILED',
      style: 'danger',
    },
  ],

  CONFIRM_XML_STATUSES: [
    {
      value: 'accepted',
      icon: 'check-square',
      label: 'ACCEPTED',
      style: 'success',
    },
    {
      value: 'accepted_partially',
      icon: 'check-square-o',
      label: 'PARTIALLY_ACCEPTED',
      style: 'warning',
    },
    { value: 'rejected', icon: 'ban', label: 'REJECTED', style: 'danger' },
    {
      value: 'confirm_later',
      icon: 'hourglass',
      label: 'N/A',
      style: 'default',
    },
  ],

  TRANSACTION_TYPES: [
    {
      name: 'BOOKINGS',
      value: 'bookings',
      icon: 'file-text-o',
      numberingOptions: ['automatic', 'random'],
    },
    {
      name: 'INVOICES',
      value: 'invoices',
      icon: 'file-text-o',
      numberingOptions: ['automatic', 'manual', 'random'],
    },
    {
      name: 'CLIENT_CREDIT_NOTES',
      value: 'client_credit_notes',
      icon: 'file-o',
      numberingOptions: ['automatic', 'manual', 'random'],
    },
    {
      name: 'RECEIVED_PAYMENTS',
      value: 'received_payments',
      icon: 'money',
      numberingOptions: ['automatic', 'manual', 'random'],
    },
    {
      name: 'CLIENT_DEBIT_NOTES',
      value: 'client_debit_notes',
      icon: 'file-o',
      numberingOptions: ['automatic', 'manual', 'random'],
    },
    {
      name: 'BILLS',
      value: 'bills',
      icon: 'file-o',
      numberingOptions: ['automatic', 'manual', 'random'],
    },
    {
      name: 'PAYMENT_PROVIDERS',
      value: 'payment_providers',
      icon: 'file-o',
      numberingOptions: ['automatic', 'manual', 'random'],
    },
    {
      name: 'PROVIDER_CREDIT_NOTES',
      value: 'provider_credit_notes',
      icon: 'file-o',
      numberingOptions: ['automatic', 'manual', 'random'],
    },
    {
      name: 'RECIPIENT_CONFIRMATION',
      value: 'recipient_confirmation',
      icon: 'file-o',
      numberingOptions: ['automatic'],
    },
  ],

  FORMATS: ['pdf', 'XLSX'],

  CODING_TYPES: [
    { name: 'AUTOMATIC', type: 'automatic' },
    { name: 'MANUAL', type: 'manual' },
  ],

  BOOLEAN_OPTIONS: [
    { value: true, label: 'YES' },
    { value: false, label: 'NO' },
  ],

  SCHEDULE_TYPES: [
    { value: 'open', label: 'OPEN' },
    { value: 'fixed', label: 'FIXED' },
  ],

  STATUS: [
    { value: 'active', label: 'ACTIVE' },
    { value: 'inactive', label: 'INACTIVE' },
  ],

  COST_TYPES: [
    { name: 'PER_PERSON', type: 'per_person' },
    { name: 'PER_SERVICE', type: 'per_service' },
  ],

  COST_BASED_TYPES: [
    {
      name: 'STANDARD_COST_BASED',
      description: 'STANDARD_COST_BASED',
      value: false,
    },
    {
      name: 'SERVICE_ITEMS_COST_BASED',
      description: 'SERVICE_ITEMS_COST_BASED',
      value: true,
    },
  ],

  COMPUTATION_TYPES: [
    { name: 'PERCENTAGE', value: 'percentage' },
    { name: 'FIXED', value: 'fixed' },
  ],

  SCOPE_TYPES: [
    { name: 'SALES', value: 'sales' },
    { name: 'PURCHASES', value: 'purchases' },
  ],

  SALE_TYPES: [
    { name: 'INVOICE', value: 'invoice' },
    { name: 'INCOMING_PREPAYMENT', value: 'incoming_prepayment' },
  ],

  PURCHASE_TYPES: [
    { name: 'BILL', value: 'bill' },
    { name: 'OUTGOING_PREPAYMENT', value: 'outgoing_prepayment' },
  ],

  RESOURCE_TYPES: [
    { name: 'CONTACT', type: 'contact' },
    { name: 'VEHICLE', type: 'vehicle' },
  ],

  RESOURCE_CONTACT_TYPES: [
    { name: 'PROVIDER', type: 'provider' },
    { name: 'TEAM_MEMBER', type: 'team_member' },
  ],

  PREPAYMENT_PAYMENT_TIMES: [
    { name: 'ON_BOOKING_DATE', payment_time: 'on_booking_date' },
    { name: 'DAYS_BEFORE_SERVICE', payment_time: 'days_before_service' },
    { name: 'ON_SERVICE_DATE', payment_time: 'on_service_date' },
    { name: 'PAY_LATER', payment_time: 'pay_later' },
  ],

  // INCOMING_PREPAYMENT_PAYMENT_TIMES: [
  //     { name: 'ON_BOOKING_DATE',     payment_time: 'on_booking_date' },
  //     { name: 'DAYS_BEFORE_SERVICE', payment_time: 'days_before_service' },
  //     { name: 'ON_SERVICE_DATE',     payment_time: 'on_service_date' },
  //     { name: 'PAY_LATER',           payment_time: 'pay_later' }
  // ],

  TODAY_DATE: moment().format('YYYY-MM-DD'),
  DATE_FORMAT_DB: 'YYYY-MM-DD',
  DATE_FORMAT: 'MM/DD/YYYY',
  DATE_DISPLAY: 'MMMM DD, YYYY', // September 20, 2050
  DATE_DISPLAY_SHORT: 'MMM DD, YYYY', // Sep 20, 2050
  DATE_DISPLAY_SHORT_HOUR: 'MMM DD, YYYY | hh:mm a', // Aug 24, 2050 | 01:29 pm
  DATE_DISPLAY_LARGE: 'dddd - MMMM DD, YYYY', // Monday - December 20, 2050
  HOUR_DISPLAY_24: 'HH:mm a', // a 13:00 PM
  HOUR_DISPLAY: 'hh:mm a', // a 01:00 PM

  SALES_REPORT_GROUP_BY: [
    { name: 'NONE', value: '' }, // null
    // { 'name': 'CURRENCY',      value: 'currency' },
    { name: 'CLIENT', value: 'client' },
    { name: 'DOCUMENT_TYPE', value: 'document_type' },
  ],

  PURCHASES_REPORT_GROUP_BY: [
    { name: 'NONE', value: '' }, // null
    { name: 'PROVIDER', value: 'provider' },
    { name: 'DOCUMENT_TYPE', value: 'document_type' },
  ],
};

export default obj;
